// import React, { useState } from 'react';
// import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
// import axios from 'axios';

// // const BACKEND_URL = "http://127.0.0.1:8000";
// const BACKEND_URL = "https://linkinprofessionals.com/wp-json/vlinkin/v1";

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     program: '',
//     message: ''
//   });
//   const [status, setStatus] = useState({ type: '', message: '' });
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = async (e) => {
//   e.preventDefault();
//   setIsSubmitting(true);
//   setStatus({ type: '', message: '' });

//   try {
//     await axios.post(
//       `${BACKEND_URL}/api/contact`,
//       formData,
//       {
//         headers: {
//           "Content-Type": "application/json"
//         }
//       }
//     );

//     setStatus({ type: 'success', message: 'Thank you! We will contact you soon.' });
//     setFormData({ name: '', email: '', phone: '', program: '', message: '' });

//   } catch (error) {
//     console.error("API ERROR:", error.response || error);
//     setStatus({ type: 'error', message: 'Something went wrong. Please try again.' });
//   } finally {
//     setIsSubmitting(false); // ✅ MUST ADD
//   }
// };
//   return (
//     <section id="contact" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50" data-testid="contact-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
//             Get In <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Touch</span>
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Ready to start your journey? Contact us today and let's transform your future together
//           </p>
//         </div>

//         <div className="grid md:grid-cols-2 gap-12">
//           {/* Contact Information */}
//           <div className="space-y-8">
//             <div>
//               <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
              
//               {/* Bangalore Office */}
//               <div className="bg-white rounded-xl p-6 shadow-lg mb-6" data-testid="bangalore-office">
//                 <h4 className="font-bold text-lg text-blue-600 mb-3">Bangalore Office</h4>
//                 <div className="space-y-3 text-gray-600">
//                   <div className="flex items-start gap-3">
//                     <FaMapMarkerAlt className="text-blue-600 mt-1 flex-shrink-0" />
//                     <p>#30, 2nd Floor, Raghuvanhalli<br />Kanakpura Main Road<br />Bengaluru, Karnataka 560062</p>
//                   </div>
//                   <div className="flex items-center gap-3">
//                     <FaPhone className="text-blue-600" />
//                     <a href="tel:+918971703730" className="hover:text-blue-600">+91 89717 03730</a>
//                   </div>
//                 </div>
//               </div>

//               {/* Mysore Office */}
//               <div className="bg-white rounded-xl p-6 shadow-lg mb-6" data-testid="mysore-office">
//                 <h4 className="font-bold text-lg text-purple-600 mb-3">Mysore Office</h4>
//                 <div className="space-y-3 text-gray-600">
//                   <div className="flex items-start gap-3">
//                     <FaMapMarkerAlt className="text-purple-600 mt-1 flex-shrink-0" />
//                     <p>#5490, Dr Mh Ambareesha Road<br />Water Tank Circle, Vijayanagar<br />2nd Stage Mysore 570017</p>
//                   </div>
//                   <div className="flex items-center gap-3">
//                     <FaPhone className="text-purple-600" />
//                     <a href="tel:+918971504452" className="hover:text-purple-600">+91 8971504452</a>
//                   </div>
//                 </div>
//               </div>

//               {/* Email */}
//               <div className="bg-white rounded-xl p-6 shadow-lg">
//                 <div className="flex items-center gap-3 text-gray-600">
//                   <FaEnvelope className="text-orange-600 text-xl" />
//                   <a href="mailto:info@linkinprofessionals.com" className="hover:text-orange-600">
//                     info@linkinprofessionals.com
//                   </a>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Contact Form */}
//           <div className="bg-white rounded-xl p-8 shadow-xl">
//             <h3 className="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h3>
//             <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
//               <div>
//                 <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
//                   Full Name *
//                 </label>
//                 <input
//                   type="text"
//                   id="name"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   placeholder="Your Name"
//                   data-testid="contact-name-input"
//                 />
//               </div>

//               <div>
//                 <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
//                   Email Address *
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   placeholder="your.email@example.com"
//                   data-testid="contact-email-input"
//                 />
//               </div>

//               <div>
//                 <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
//                   Phone Number *
//                 </label>
//                 <input
//                   type="tel"
//                   id="phone"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   required
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   placeholder="+91 XXXXX XXXXX"
//                   data-testid="contact-phone-input"
//                 />
//               </div>

//               <div>
//                 <label htmlFor="program" className="block text-sm font-medium text-gray-700 mb-2">
//                   Interested Program
//                 </label>
//                 <select
//                   id="program"
//                   name="program"
//                   value={formData.program}
//                   onChange={handleChange}
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   data-testid="contact-program-select"
//                 >
//                   <option value="">Select a Program</option>
//                   <option value="super50">Super 50 Program</option>
//                   <option value="bootcamp">Bootcamps</option>
//                   <option value="other">Other / General Inquiry</option>
//                 </select>
//               </div>

//               <div>
//                 <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
//                   Message
//                 </label>
//                 <textarea
//                   id="message"
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   rows="4"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   placeholder="Tell us about your goals and questions..."
//                   data-testid="contact-message-input"
//                 ></textarea>
//               </div>

//               {status.message && (
//                 <div
//                   className={`p-4 rounded-lg ${status.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
//                   data-testid="contact-form-status"
//                 >
//                   {status.message}
//                 </div>
//               )}

//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//                 data-testid="contact-submit-btn"
//               >
//                 {isSubmitting ? 'Sending...' : 'Send Message'}
//                 <FaPaperPlane />
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;
import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import axios from 'axios';

// const BACKEND_URL = "http://127.0.0.1:8000";
const BACKEND_URL = "https://linkinprofessionals.com/back_up/wp-json/vlinkin/v1";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    program: '',
    message: ''
  });
  const [status, setStatus] = useState({ type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: '', message: '' });

    try {
      await axios.post(
        `${BACKEND_URL}/contact`,   // ✅ FIXED: removed extra /api/ prefix
        formData,
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      setStatus({ type: 'success', message: 'Thank you! We will contact you soon.' });
      setFormData({ name: '', email: '', phone: '', program: '', message: '' });

    } catch (error) {
      console.error("API ERROR:", error.response || error);
      setStatus({ type: 'error', message: 'Something went wrong. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-blue-50 to-purple-50" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Get In <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Touch</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready to start your journey? Contact us today and let's transform your future together
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>

              {/* Bangalore Office */}
              <div className="bg-white rounded-xl p-6 shadow-lg mb-6" data-testid="bangalore-office">
                <h4 className="font-bold text-lg text-blue-600 mb-3">Bangalore Office</h4>
                <div className="space-y-3 text-gray-600">
                  <div className="flex items-start gap-3">
                    <FaMapMarkerAlt className="text-blue-600 mt-1 flex-shrink-0" />
                    <p>#30, 2nd Floor, Raghuvanhalli<br />Kanakpura Main Road<br />Bengaluru, Karnataka 560062</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <FaPhone className="text-blue-600" />
                    <a href="tel:+918971703730" className="hover:text-blue-600">+91 89717 03730</a>
                  </div>
                </div>
              </div>

              {/* Mysore Office */}
              <div className="bg-white rounded-xl p-6 shadow-lg mb-6" data-testid="mysore-office">
                <h4 className="font-bold text-lg text-purple-600 mb-3">Mysore Office</h4>
                <div className="space-y-3 text-gray-600">
                  <div className="flex items-start gap-3">
                    <FaMapMarkerAlt className="text-purple-600 mt-1 flex-shrink-0" />
                    <p>#5490, Dr Mh Ambareesha Road<br />Water Tank Circle, Vijayanagar<br />2nd Stage Mysore 570017</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <FaPhone className="text-purple-600" />
                    <a href="tel:+918971504452" className="hover:text-purple-600">+91 8971504452</a>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div className="bg-white rounded-xl p-6 shadow-lg">
                <div className="flex items-center gap-3 text-gray-600">
                  <FaEnvelope className="text-orange-600 text-xl" />
                  <a href="mailto:info@linkinprofessionals.com" className="hover:text-orange-600">
                    info@linkinprofessionals.com
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-xl p-8 shadow-xl">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Send us a Message</h3>
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Your Name"
                  data-testid="contact-name-input"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  Email Address *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="your.email@example.com"
                  data-testid="contact-email-input"
                />
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-2">
                  Phone Number *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="+91 XXXXX XXXXX"
                  data-testid="contact-phone-input"
                />
              </div>

              <div>
                <label htmlFor="program" className="block text-sm font-medium text-gray-700 mb-2">
                  Interested Program
                </label>
                <select
                  id="program"
                  name="program"
                  value={formData.program}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  data-testid="contact-program-select"
                >
                  <option value="">Select a Program</option>
                  <option value="super50">Super 50 Program</option>
                  <option value="bootcamp">Bootcamps</option>
                  <option value="other">Other / General Inquiry</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Tell us about your goals and questions..."
                  data-testid="contact-message-input"
                ></textarea>
              </div>

              {status.message && (
                <div
                  className={`p-4 rounded-lg ${status.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}
                  data-testid="contact-form-status"
                >
                  {status.message}
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-4 rounded-lg font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                data-testid="contact-submit-btn"
              >
                {isSubmitting ? 'Sending...' : 'Send Message'}
                <FaPaperPlane />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;